import { zh } from './zh';
import { en } from './en';
import { zhHant } from './zh-Hant';

export type Language = 'zh' | 'zh-Hant' | 'zh-TW' | 'en';
export type Translations = typeof zh;

const translations: Record<Language, Translations> = {
  zh,
  'zh-Hant': zhHant,
  'zh-TW': zhHant,
  en,
};

const isLanguage = (value: string | null): value is Language =>
  value === 'zh' || value === 'zh-Hant' || value === 'zh-TW' || value === 'en';

// 获取浏览器默认语言
const getBrowserLanguage = (): Language => {
  const full = navigator.language || '';
  const lower = full.toLowerCase();
  if (lower.startsWith('zh-tw')) return 'zh-TW';
  if (lower.startsWith('zh-hk') || lower.startsWith('zh-mo') || lower.includes('hant')) {
    return 'zh-Hant';
  }
  const lang = full.split('-')[0];
  if (lang === 'zh') return 'zh';
  if (lang === 'en') return 'en';
  return 'en';
};

// 从 localStorage 获取保存的语言设置
const getStoredLanguage = (): Language | null => {
  const stored = localStorage.getItem('language');
  return isLanguage(stored) ? stored : null;
};

// 获取当前语言
export const getCurrentLanguage = (): Language => {
  return getStoredLanguage() || getBrowserLanguage();
};

// 是否为中文界面（简体或繁体）
export const isChineseLanguage = (lang: Language = getCurrentLanguage()) =>
  lang === 'zh' || lang === 'zh-Hant' || lang === 'zh-TW';

// 是否为繁体界面
export const isTraditionalChinese = (lang: Language = getCurrentLanguage()) =>
  lang === 'zh-Hant' || lang === 'zh-TW';

// 设置语言
export const setLanguage = (lang: Language) => {
  localStorage.setItem('language', lang);
  window.location.reload(); // 刷新页面以应用新语言
};

// 获取翻译文本；vars 用于替换 `{count}` 这类占位符
export const t = (key: string, vars?: Record<string, string | number>): string => {
  const lang = getCurrentLanguage();
  const translation = translations[lang];
  
  // 支持嵌套对象的访问，例如 'profile.title'
  const keys = key.split('.');
  let result: any = translation;
  
  for (const k of keys) {
    if (result && typeof result === 'object' && k in result) {
      result = result[k];
    } else {
      return key;
    }
  }
  
  if (typeof result !== 'string') return key;
  if (!vars) return result;
  return Object.entries(vars).reduce(
    (text, [name, value]) => text.replace(new RegExp(`\\{${name}\\}`, 'g'), String(value)),
    result,
  );
};
